import styled from 'styled-components';
import { Color } from '~/styles';

export const Row = styled.div`
  display: flex;
  margin-bottom: 24px;
  justify-content: center;
`;

export const ErrorsText = styled.div`
  color: ${Color.red};

  font-size: 12px;
  font-weight: bold;
`;

export const ErrorsTextModal = styled.p`
  color: var(--Preto, #000);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 70%;
`;
